/**
 * @module ol/functions
 */

/**
 * Always returns true.
 * @returns {boolean} true.
 */
export function TRUE() {
  return true;
}

/**
 * Always returns false.
 * @returns {boolean} false.
 */
export function FALSE() {
  return false;
}

/**
 * A reusable function, used e.g. as a default for callbacks.
 *
 * @return {void} Nothing.
 */
export function VOID() {}

//# sourceMappingURL=functions.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/ol/functions.js
// module id = ../../../../ol/functions.js
// module chunks = 3